import {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";

import { onAuthStateChanged } from "firebase/auth";

import { auth } from "../firebase";

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
    console.log("Registering auth listener");

    const unsubscribe = onAuthStateChanged(
        auth,
        (user) => {
            console.log("onAuthStateChanged fired", user);

            setUser(user);
            setLoading(false);
        },
        (error) => {
            console.error("Auth listener error", error);
        }
    );

    console.log("Listener registered");

    return unsubscribe;
}, []);

useEffect(() => {
    console.log("loading =", loading);
}, [loading]);

    return (
        <AuthContext.Provider
            value={{
                user,
                loading,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}